import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ListItem } from 'material-ui/List';
import { grey600 } from 'material-ui/styles/colors';
import Icon from 'material-ui/svg-icons/maps/map';
import Avatar from 'material-ui/Avatar';
import withTranslation from '../../../hoc/withTranslation';
import { ROAD_BOOK_CONFIGURATION_PAGE } from '../../../constants/routes';

class RoadBookConfigurationItem extends React.Component {
    static propTypes = {
        roadBookConfiguration: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
    };

    render() {
        const {
            roadBookConfiguration,
            app,
            t,
        } = this.props;
        return (
            <div>
                {app && roadBookConfiguration && <Link
                    to={
                        ROAD_BOOK_CONFIGURATION_PAGE.replace(':appId', app.id)
                            .replace(':roadBookConfigurationId', roadBookConfiguration.id)
                    }
                >
                    <ListItem
                        style={!roadBookConfiguration.is_activated ? {backgroundColor: "rgba(0,0,0,0.05)"} : {}}
                        insetChildren={true}
                        leftAvatar={<Avatar icon={<Icon/>}/>}
                        primaryText={
                            <div>
                                {roadBookConfiguration.name || t('module.road_book.no_name')}
                                {!roadBookConfiguration.is_activated &&
                                    <span
                                        style={{fontStyle: "italic", color: grey600}}>
                                        {' - ' + t('generic.disabled')}
                                    </span>
                                }
                            </div>
                        }
                        disableKeyboardFocus={true}
                    />
                </Link>}
            </div>
        );
    }
}

export default withTranslation(RoadBookConfigurationItem);



// WEBPACK FOOTER //
// src/components/roadbook/RoadBookConfigurationList/RoadBookConfigurationItem.js